<template>
  <form @submit.prevent>
    <CModal
        :title.sync="title"
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">

        <strong > Kids Information </strong>
            <CRow class="mt-3" v-if="!loading_info">
              <CCol >

                <label> {{ "Name: " + form.firstname + ' ' + form.lastname }} </label>
              </CCol>
            </CRow>
            <hr>
            <strong > Parents Information </strong>
             <CRow  class="mt-3" v-if="!loading_parent">
              <CCol>
                <label> {{ "Dad: " + dad  }} </label>
              </CCol>
              <CCol>
                <label> {{ "Mom: " + mom  }} </label>
              </CCol>
            </CRow>
            <CRow v-else class="center"><b-spinner variant="primary" label="Spinning"><br></b-spinner></CRow>

            <hr>
            <CCol>
                     <CInput v-model="form.ikid_id" hidden  />
                  </CCol>
        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton type="submit" v-on:click.prevent="checkin()"  variant="outline" color="info">Check In</CButton>
      </template>
    </CModal>
  </form>
</template>

<script>
import moment from 'moment';
import EventBus from '@/eventBus';
import { ModelSelect } from 'vue-search-select'
import ikid from '@/services/ikid'
import QRCode from 'qrcode';
import axios from 'axios'


export default {
name: 'keperluanmodal',
components: {ModelSelect },
  data () {
    return {
      show: false,
      loading_info: false,
      loading_parent: false,
      loading_class: false,
      title: '',
      mode: '',
      options_class: [],
      options_dad: [],
      options_mom: [],
      dad_id:'',
      mom_id:'',
      dad:'',
      mom:'',
      form:{
        ikid_id:'',
        status:'',
        from:'portal',
      },
      options: ['Male', 'Female'],
      radioNames: ['Gender',]
    }
  },
  mounted(){

  },
  created () {
    var self = this;
    EventBus.$on('OPEN_MODAL_IKID_CHECKIN', (params) => {
      if(params.data){
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.loading_info = true;
        this.getParent() //GET PARENT ACTIVE

        ikid.getIkidbyID(params.data)
        .then(res => {
          self.form.id = res.data.id;
          self.form.uuid = res.data.uuid;
          self.form.firstname = res.data.firstname;
          self.form.lastname = res.data.lastname;
          self.form.dob = res.data.dob;
          self.form.class_id = res.data.ikid_class.name;
          self.form.sex = res.data.sex;
          self.form.people_id = params.data;
          self.form.ikid_id = res.data.id;
          self.form.barcode = res.data.barcode;
          // self.form.check_time = res.data.checkin_time = moment(this.form.check_time).format ('DD/MM/YYYY hh:mm:ss')
          if(res.data.dad !== null){
                this.dad = res.data.dad.firstname + " " + res.data.dad.lastname
                this.form.dad_id = res.data.dad.id
            }
            else{
            this.dad = "still not assigned"
            }
            if(res.data.mom !== null){
                this.mom = res.data.mom.firstname + " " + res.data.mom.lastname
                this.form.mom_id = res.data.mom.id
          }
          else{
            this.mom = "still not assigned"
          }
          self.loading_info = false;
        }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{

        this.getParent() //GET PARENT ACTIVE


        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.id = "";
        self.form.name = "";
      }
    });
  },

  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    // checkin(){
    //   this.show = false;
    //   // ikid.checkinKid(this.form)
    //   this.form.check_time = moment().format('DD/MM/YYYY HH:mm:ss');
    //   this.form.status = 1;
    //   ikid.changeStatusKid(this.form)
    //   .then(res => {
    //     // force checkin
    //     setTimeout(() => {
    //         // this.form.ikid_id = uuid;
    //         this.form.status = 2;
    //         ikid.changeStatusKid(this.form)
    //         .then(res => {
    //           EventBus.$emit('TABLE_UPDATE_IKIDS_CHECK', true)
    //           // var params = {title: 'Success', mode:'success', data:res.message}
    //           // EventBus.$emit('OPEN_MODAL_ALERT', params)
    //           setTimeout(() => {
    //           const newWindow = window.open('', '_blank');

    //           newWindow.document.write('    <div style="width: fit-content; padding: 10px; border-radius: 4px; border: solid 1px #ccc; text-align: center;">');
    //           newWindow.document.write('    <div style="font-size: 14px; font-weight: bold; margin-bottom: 10px;">IFGF KID PICK-UP CARD</div>');
    //           newWindow.document.write('    <strong>'+this.form.firstname+ ' ' +this.form.lastname+'</strong> <br>');
    //           newWindow.document.write('    Class : '+this.form.class_id+' <br>');
    //           newWindow.document.write('    Check In : '+this.form.check_time+'');
    //           newWindow.document.write('    <hr>');
    //           newWindow.document.write('    <center>');

    //           const qrCanvas = document.createElement('canvas');
    //           // add # for end of value to prevent double input
    //           const qrCodeValue = this.form.uuid+'#';

    //           QRCode.toCanvas(qrCanvas, qrCodeValue, (error) => {
    //             if (error) {
    //               console.error(error);
    //               return;
    //             }
    //           const qrCodeImage = qrCanvas.toDataURL('image/png');

    //           newWindow.document.write('<img src="' + qrCodeImage + '" width="175" height="auto" />');
    //           newWindow.document.write('    </center>');
    //           newWindow.document.write('</div>');
    //           newWindow.document.close();

    //           newWindow.onload = function() {
    //             newWindow.print();
    //           };
    //           });

    //       });
    //         }).catch ((err) => {
    //           var params = {title: 'Error', mode:'danger', data:err.response.data.message}
    //           EventBus.$emit('OPEN_MODAL_ALERT', params)
    //         })
    //       }, 1000);

    //   }).catch ((err) => {
    //     var params = {title: 'Error', mode:'danger', data:err.response.data.message}
    //     EventBus.$emit('OPEN_MODAL_ALERT', params)
    //   })
    // },
    checkin(){
      this.show = false;
      // ikid.checkinKid(this.form)
      this.form.check_time = moment().format('DD/MM/YYYY HH:mm:ss');
      this.form.status = 1;
      ikid.changeStatusKidInClass(this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE_IKIDS_CHECK', true)

        this.connectToPrinter();

        // setTimeout(() => {
        //   const newWindow = window.open('', '_blank');

        //   newWindow.document.write('    <div style="width: fit-content; padding: 10px; border-radius: 4px; border: solid 1px #ccc; text-align: center;">');
        //   newWindow.document.write('    <div style="font-size: 14px; font-weight: bold; margin-bottom: 10px;">IFGF KID PICK-UP CARD</div>');
        //   newWindow.document.write('    <strong>'+this.form.firstname+ ' ' +this.form.lastname+'</strong> <br>');
        //   newWindow.document.write('    Class : '+this.form.class_id+' <br>');
        //   newWindow.document.write('    Check In : '+this.form.check_time+'');
        //   newWindow.document.write('    <hr>');
        //   newWindow.document.write('    <center>');

        //   const qrCanvas = document.createElement('canvas');
        //   // add # for end of value to prevent double input
        //   const qrCodeValue = this.form.barcode+'#';

        //   QRCode.toCanvas(qrCanvas, qrCodeValue, (error) => {
        //     if (error) {
        //       console.error(error);
        //       return;
        //     }
        //     const qrCodeImage = qrCanvas.toDataURL('image/png');

        //     newWindow.document.write('<img src="' + qrCodeImage + '" width="175" height="auto" />');
        //     newWindow.document.write('    </center>');
        //     newWindow.document.write('</div>');
        //     newWindow.document.close();

        //     newWindow.onload = function() {
        //       newWindow.print();
        //     };
        //   });
        // });
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    //GET PARENT ACTIVE
    getParent(){
      this.loading_parent = true
      this.options_dad = []
      this.options_mom = []
      ikid.getIkidParent()
      .then(res => {
        for(let i = 0; i <= res.dad.length-1; i++){
          this.options_dad.push({text: res.dad[i].firstname + ' ' + res.dad[i].lastname, value: res.dad[i].id});
        }
        for(let i = 0; i <= res.mom.length-1; i++){
          this.options_mom.push({text: res.mom[i].firstname + ' ' + res.mom[i].lastname, value: res.mom[i].id});
        }
        this.loading_parent = false
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })

    },
    async connectToPrinter() {
      const firstname = this.form.firstname;
      const lastname = this.form.lastname;
      const class_id = this.form.class_id;
      const check_time = moment().format('DD/MM/YYYY HH:mm:ss');
      const barcode = this.form.barcode;

      try {
        const response = await axios.post('http://localhost:3000/print', {
          firstname: firstname,
          lastname: lastname,
          class_id: class_id,
          check_time: check_time,
          barcode: barcode
        },
        {
          timeout: 5000, // Timeout set to 5000ms (5 seconds)
        });
      } catch (error) {
        console.log('Error connecting to printer:', error);
        console.log('ID:', id);
      }
    },
  }
}
</script>

<style>
.center {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>